import React, { Component } from 'react';
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap';
import Loader from '../../../common/loader';
import ModalComponent from '../../../components/ModalComponent/ModalComponent';
import API from '../services';
import dashboardTabsAPIKeysList from './Config/tabList';
import EditReportModalBody from './EditReportModalBody';
import TabActionButton from './TabActionButton';
import { renderHTMLContent } from '../../../common/function';

export default class TabList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      TabHeader: '',
      currentIndex: 0,
      storageSession: JSON.parse(localStorage.getItem('localstorageval')),
      tabsData: [],
      isLoading: false,
      selectedExam: localStorage.getItem('selectedmenu'),
      deleteCSS: 'fa fa-trash mark-action-btn-dashboard',
      viewCSS: 'fa fa-eye mark-action-btn-dashboard',
      editCSS: 'fa fa-pencil-square-o mark-action-btn-dashboard',
      viewFeedbackCSS: 'fa fa-exclamation-circle fa-rotate-180 mark-action-btn-dashboard',
      apiService: '',
      reportedItem: '',
      reportComment: '',
      reportEditHeader: '',
      reportEditItem: {},
      reportModelOpen: false,
      isReportEditModalOpen: false,
      isReportErrorMessageDisplay: 'd-none',
      isViewFeedbackModalOpen: false,
      selectedFeedbackItemId: null,
    };
  }

  onViewFeedbackModalToggle = (_apiService, items) => {
    const willOpen = !this.state.isViewFeedbackModalOpen;
    this.setState({
      isViewFeedbackModalOpen: willOpen,
      selectedFeedbackItemId: willOpen && items ? items.id : null,
    });
  };
  static contextTypes = {
    router: React.PropTypes.object,
  };
  componentDidMount = async () => {
    const { selectedExam, currentIndex } = this.state;
    dashboardTabsAPIKeysList[selectedExam].length && this.getData(currentIndex);
  };

  getData = async index => {
    const { selectedExam } = this.state;
    this.setState({ isLoading: true });
    const { storageSession } = this.state;
    const data = {
      token: storageSession.token,
      idname: storageSession.idname,
    };
    this.setState(
      {
        currentIndex: index,
        tabsData: [],
      },
      async () => {
        const {
          state: { currentIndex },
          props: { section },
        } = this;
        const tabsData = await API[dashboardTabsAPIKeysList[selectedExam][currentIndex][section]](
          data,
        );
        this.setState({
          tabsData: tabsData.success ? tabsData.data : [],
          isLoading: false,
        });
      },
    );
  };

  onView = async (apiService, items) => {
    const { currentIndex, selectedExam, storageSession } = this.state;
    const getTabsData = dashboardTabsAPIKeysList[selectedExam][currentIndex];

    const data = {
      token: storageSession.token,
      idname: storageSession.idname,
    };
    const getParameterList = await API[apiService]({ ...items, ...data });
    // console.log('...items', ...items);
    this.context.router.push({
      pathname: await this.onNavigateTo(getTabsData.redirectionPath, getParameterList.data),
    });
  };

  onNavigateTo = (path, parameterList) => {
    // console.log('path', path, parameterList);
    let navigateURL = path;
    for (const key in parameterList) {
      navigateURL = navigateURL.replace(`:${key}`, parameterList[key]);
    }
    return navigateURL;
  };

  onDelete = async (apiService, items) => {
    const { storageSession, currentIndex } = this.state;
    const { id, item_id, flash_card } = items;
    const data = {
      token: storageSession.token,
      idname: storageSession.idname,
    };
    if (flash_card) {
      const payload = {
        id_name: storageSession.idname,
        token: storageSession.token,
        type: apiService === 'deleteSavedQuestion' ? 'question' : 'video',
        question_type: '',
        exam: 'esg',
        level: '',
        item_id,
      };
      await API['deleteFlashCard'](payload);
    }
    const tabsData = await API[apiService]({ ...data, id });
    if (tabsData.success) {
      this.getData(currentIndex);
      this.setState({
        apiService: '',
        reportedItem: '',
        reportModelOpen: false,
      });
    } else {
      this.setState({
        apiService: '',
        reportedItem: '',
        reportModelOpen: false,
      });
    }
  };
  toggleAlertReport = async (apiService, items) => {
    this.setState({
      reportModelOpen: !this.state.reportModelOpen,
      apiService,
      reportedItem: items,
    });
  };

  onReportCommentChange = event => {
    this.setState({ reportComment: event.target.value, isReportErrorMessageDisplay: 'd-none' });
  };
  onReportEditModalToggle = async (apiService, items) => {
    const { isReportEditModalOpen } = this.state;
    if (!isReportEditModalOpen) {
      const { comment, tableKey, tableName } = items;
      const getReportHeaderText = items[tableName][tableKey];

      const reportModalHeader =
        getReportHeaderText.length > 150
          ? ` ${getReportHeaderText.substr(0, 100)}...`
          : ` ${getReportHeaderText}`;

      this.setState(
        {
          reportComment: comment,
          reportEditItem: { ...items, apiService },
          reportEditHeader: reportModalHeader,
          isReportErrorMessageDisplay: 'd-none',
        },
        () => {
          this.setState({
            isReportEditModalOpen: !this.state.isReportEditModalOpen,
            isReportErrorMessageDisplay: 'd-none',
          });
        },
      );
    } else {
      this.setState({
        isReportEditModalOpen: !this.state.isReportEditModalOpen,
        reportEditItem: {},
        reportComment: '',
        reportEditHeader: '',
        isReportErrorMessageDisplay: 'd-block',
      });
    }
  };
  onReportEditSubmit = async event => {
    event.preventDefault();
    const { reportComment, reportEditItem, storageSession, currentIndex } = this.state;
    const { apiService, id } = reportEditItem;
    if (reportComment.trim().length) {
      const data = {
        token: storageSession.token,
        idname: storageSession.idname,
      };
      const editReport = await API[apiService]({ ...data, id, comment: reportComment });
      if (editReport.success) {
        this.setState(
          {
            isReportEditModalOpen: !this.state.isReportEditModalOpen,
            isReportErrorMessageDisplay: 'd-none',
            reportEditItem: {},
            reportComment: '',
            reportEditHeader: '',
          },
          () => {
            this.getData(currentIndex);
          },
        );
      }
    } else {
      this.setState({
        isReportErrorMessageDisplay: 'd-block',
        reportEditItem: {},
      });
    }
  };
  render() {
    const { TabHeader, section } = this.props;
    const {
      currentIndex,
      tabsData,
      isLoading,
      selectedExam,
      deleteCSS,
      viewCSS,
      editCSS,
      viewFeedbackCSS,
      reportModelOpen,
      apiService,
      reportedItem,
      isReportEditModalOpen,
      isReportErrorMessageDisplay,
      // reportEditItem,
      reportComment,
      reportEditHeader,
      isViewFeedbackModalOpen,
      selectedFeedbackItemId,
    } = this.state;
    const showTabsData = dashboardTabsAPIKeysList[selectedExam][currentIndex];
    const {
      savedItemTitle,
      saveItemTableName,
      savedItemTableKey,
      reportedItemTableKey,
      idFieldName,
    } = showTabsData;

    return (
      <div>
        <div className='padding_bottom_30'>
          <h1 className='section_head padding_bottom_30'>{TabHeader}</h1>
          <div className='d-flex header-card-dashboard tab-header-wrap'>
            <ul className='dashboard-card-header-tab'>
              {/* ===========> {{ REPORTED AND SAVED ITEM TAB STARTED HERE }} <============ */}
              {dashboardTabsAPIKeysList[selectedExam].map((tab, index) => {
                if (!dashboardTabsAPIKeysList[selectedExam][index][section]) {
                  return null;
                }
                return (
                  <li
                    key={tab.label}
                    onClick={() => {
                      this.getData(index);
                    }}
                    className={currentIndex === index ? 'active' : ''}
                  >
                    <span> {tab.label}</span>
                  </li>
                );
              })}
              {/* ===========> {{ REPORTED AND SAVED ITEM TAB  ENDED  HERE }} <============ */}
            </ul>
          </div>
          {/* ===========> {{ REPORTED AND SAVED ITEM TAB CARD BODY STARTED HERE }} <=========== */}
          <div className='card tab-body-wrap'>
            <div className='card-block dashboard-cards-scroll my-1'>
              <div className='chart-wrapper'>
                {isLoading ? (
                  <div className='card-block-loader'>
                    <Loader />
                  </div>
                ) : tabsData.length ? (
                  tabsData.map((items, index) => {
                    const topic =
                      items[`${saveItemTableName}.${savedItemTableKey}`]
                        ? items[`${saveItemTableName}.${savedItemTableKey}`]
                        : items[`${savedItemTableKey}`]
                          ? items[`${savedItemTableKey}`]
                          : '';

                    return (
                      <div id={`savedque_${items.id}`} key={index} className='flash_card_box'>
                        {/* --------->  CONDITION FOR ONLY RESOLVED AND PENDING TAG <--------- */}
                        {section === 'reportAPIService' && (
                          <div className='mb-1'>
                            <span>
                              <strong> {'Ticket ID'}: </strong> {items.id}
                            </span>

                            <span
                              className={`float-right status-${items.status === 'resolved' ? 'resolved' : 'pending'
                                }`}
                            >
                              <strong className='text-capitalize'>
                                {items.status === 'resolved' ? 'resolved' : 'pending'}
                              </strong>
                            </span>
                          </div>
                        )}
                        <div>
                          <span>
                            <strong> {savedItemTitle}: </strong>
                            {items[idFieldName || 'id']}
                          </span>
                          <TabActionButton
                            tooltipText={'Delete'}
                            buttonCss={deleteCSS}
                            buttonColor={'#f51a00'}
                            apiService={
                              section === 'reportAPIService'
                                ? showTabsData['reportDeleteAPIService']
                                : showTabsData['saveItemDeleteAPIService']
                            }
                            OnActionButtonClick={this.toggleAlertReport}
                            items={items}
                          />
                          {/* ---> VIEW FEEDBACK ICON <--- */}
                          {/*
                            Mirrors the pattern in
                            Components-2025/dashboard/TabList.jsx.
                            The BE (esg/dashboard/reported-question,
                            /cbt-reported-question, video ESGReport
                            findAll include) returns `isSend` and `reply`
                            on each row; when the admin has sent a reply,
                            `isSend` flips true and `reply` (or `answer`
                            on some report shapes) is populated.
                            Show the "View feedback" icon in that state.
                          */}
                          {items.isSend && (items.answer || items.reply) && (
                            <TabActionButton
                              tooltipText={'View feedback'}
                              buttonCss={viewFeedbackCSS}
                              buttonColor={'#1f8ceb'}
                              apiService={showTabsData['editAPIService']}
                              OnActionButtonClick={this.onViewFeedbackModalToggle}
                              items={{
                                ...items,
                                tableName: saveItemTableName,
                                tableKey: savedItemTableKey,
                              }}
                            />
                          )}
                          <TabActionButton
                            tooltipText={'View'}
                            buttonCss={viewCSS}
                            buttonColor={'#1f8ceb'}
                            apiService={showTabsData['viewItemAPIService']}
                            OnActionButtonClick={this.onView}
                            items={items}
                          />
                          {/* --------->  CONDITION FOR ONLY EDIT REPORT BUTTON <--------- */}

                          {!items.isSend &&
                            !items.answer &&
                            items.status !== 'resolved' &&
                            section === 'reportAPIService' ? (
                            <TabActionButton
                              tooltipText={'Edit report'}
                              buttonCss={editCSS}
                              buttonColor={'#1f8ceb'}
                              apiService={showTabsData['editAPIService']}
                              OnActionButtonClick={this.onReportEditModalToggle}
                              items={{
                                ...items,
                                tableName: saveItemTableName,
                                tableKey: savedItemTableKey,
                              }}
                            />
                          ) : null}
                        </div>
                        {topic && <p className='mt-1'>
                          <strong>{'Topic'}: </strong>
                          {renderHTMLContent(
                            topic && topic.length > 150 ? `${topic.substr(0, 100)}...` : topic,
                            'span'
                          )}
                        </p>}
                        {items.flash_card && <p className='mt-1'>
                          <strong>{'Note'}: </strong>
                          {renderHTMLContent(
                            items.flash_card && items.flash_card.length > 150
                              ? `${items.flash_card.substr(0, 100)}...`
                              : items.flash_card,
                            'span'
                          )}
                        </p>}
                        {section === 'reportAPIService' && (
                          <p className='mt-1'>
                            <strong>{'Report'}: </strong>
                            {renderHTMLContent(
                              items[reportedItemTableKey].length > 150
                                ? `${items[reportedItemTableKey].substr(0, 100)}...`
                                : items[reportedItemTableKey],
                              'span'
                            )}
                          </p>
                        )}
                        {/*------------> START MODAL FOR REPORTED ITEM EDIT START HERE <------------ */}
                        <ModalComponent
                          isModalOpen={isReportEditModalOpen}
                          modalHeaderText={reportEditHeader}
                          onModalToggle={this.onReportEditModalToggle}
                        >
                          <EditReportModalBody
                            onReportEditSubmit={this.onReportEditSubmit}
                            onReportEditModalToggle={this.onReportEditModalToggle}
                            reportComment={reportComment}
                            onReportCommentChange={this.onReportCommentChange}
                            isReportErrorMessageDisplay={isReportErrorMessageDisplay}
                            reportErrorMessage={`Report can't be empty`}
                          />
                        </ModalComponent>
                        {/*------------> START MODAL FOR REPORTED ITEM EDIT ENDED HERE <------------ */}
                        {/*------------> START MODAL FOR VIEW FEEDBACK START HERE <------------ */}
                        {/*
                          One <Modal> per row, gated on
                          selectedFeedbackItemId === items.id so only the
                          row's own modal opens when its icon is clicked.
                          Body renders admin's reply (`reply` for question
                          / cbt / video reports, `answer` on older shapes)
                          via renderHTMLContent so any HTML admin authored
                          is safely stripped.
                        */}
                        <Modal
                          isOpen={
                            isViewFeedbackModalOpen &&
                            selectedFeedbackItemId === items.id
                          }
                          toggle={this.onViewFeedbackModalToggle}
                          className={'modal-primary '}
                        >
                          <ModalHeader>
                            {`Q. ${items.id}`}
                            <button
                              type='button'
                              className='close'
                              aria-label='Close'
                              onClick={this.onViewFeedbackModalToggle}
                            >
                              <span aria-hidden='true'>×</span>
                            </button>
                          </ModalHeader>
                          <ModalBody>
                            <div className='text-center'>
                              <p className='margin_bottom_20'>
                                {renderHTMLContent(
                                  items.reply || items.answer || '',
                                  'span'
                                )}
                              </p>
                            </div>
                          </ModalBody>
                        </Modal>
                        {/*------------> START MODAL FOR VIEW FEEDBACK ENDED HERE <------------ */}
                      </div>
                    );
                  })
                ) : (
                  <div className='text-center'>No data found</div>
                )}
              </div>
            </div>
          </div>
          {/* ===========> {{ REPORTED AND SAVED ITEM TAB CARD BODY  ENDED  HERE }} <============== */}
        </div>

        <Modal
          isOpen={reportModelOpen}
          toggle={this.toggleAlertReport}
          className={'modal-primary '}
        >
          <ModalHeader>
            Alert
            <button
              type='button'
              className='close'
              aria-label='Close'
              onClick={this.toggleAlertReport}
            >
              <span aria-hidden='true'>×</span>
            </button>
          </ModalHeader>
          <ModalBody>
            <div className='text-center'>
              <p className='margin_bottom_20'>
                <strong>{'Are you sure you want to delete this?'}</strong>
              </p>
              <Button
                className='btn btn-sm btn-primary'
                color='primary'
                onClick={() => this.onDelete(apiService, reportedItem)}
              >
                OK
              </Button>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/ESG/Dashboard/TabList.jsx